import {TicketTerminationStatusASM} from "./TicketTerminationStatusASM";

export const TicketTerminationStatusASMColorMapping = new Map<TicketTerminationStatusASM, string>([
  [TicketTerminationStatusASM.IN_PROGRESS, "yellow"],
  [TicketTerminationStatusASM.COMPLETED, "green"],
  [TicketTerminationStatusASM.ABORTED, "red"]
]);

export function getTicketTerminationStatusColor(status: TicketTerminationStatusASM | undefined): string {
  if(status) {
    return 'var(--traffic-light-' + TicketTerminationStatusASMColorMapping.get(status) + ', $traffic-light-' + TicketTerminationStatusASMColorMapping.get(status) + ')';
  }
  else {
    return 'var(--traffic-light-' + "off" + ', $traffic-light-' + "off" + ')';
  }
}
